import { motion } from "framer-motion";

const CHAPTERS = [
  {
    n: "01",
    title: "Growth",
    body: "I build acquisition engines that compound. Performance marketing isn't creative gymnastics — it's the ruthless pairing of intent, audience and unit economics.",
  },
  {
    n: "02",
    title: "Craft",
    body: "The stack is the studio. I stay hands-on with pixels, deduplication, LTV and MMPs. Leaders who stop touching the tools lose the plot.",
  },
  {
    n: "03",
    title: "Founder-mode",
    body: "Whether I'm running paid at Capital.com or incubating brands under Digital Centaur, the mandate is the same: budget ownership, compliance-first, measurable outcomes.",
  },
];

export default function Manifesto() {
  return (
    <section
      id="about"
      className="relative container-x py-24 md:py-40"
      data-testid="manifesto-section"
    >
      <div className="grid grid-cols-12 gap-6 md:gap-10 mb-16 md:mb-24">
        <div className="col-span-12 md:col-span-4">
          <p className="eyebrow">Manifesto</p>
        </div>
        <div className="col-span-12 md:col-span-8">
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
            className="font-serif font-light text-4xl md:text-6xl lg:text-7xl leading-[0.96] tracking-tight text-ink"
            data-testid="manifesto-title"
          >
            A performance operator who reads P&amp;Ls, then rewrites the media plan.
          </motion.h2>
        </div>
      </div>

      <div className="space-y-20 md:space-y-28">
        {CHAPTERS.map((c, i) => (
          <motion.article
            key={c.n}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-120px" }}
            transition={{ duration: 1, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
            className={`grid grid-cols-12 gap-6 md:gap-10 items-start ${
              i % 2 === 1 ? "md:pl-[10%]" : ""
            }`}
            data-testid={`manifesto-chapter-${c.n}`}
          >
            <div className="col-span-3 md:col-span-2">
              <div className="font-mono text-laser text-xs tracking-[0.28em]">CH. {c.n}</div>
              <div className="hairline my-3" />
              <div className="font-mono text-steel text-[10px] tracking-[0.24em] uppercase">
                {String(i + 1).padStart(2, "0")}/03
              </div>
            </div>
            <div className="col-span-9 md:col-span-10">
              <h3 className="font-serif font-light text-3xl md:text-5xl text-ink tracking-tight leading-none">
                {c.n} <span className="text-steel">—</span> {c.title}
              </h3>
              <p className="mt-6 md:mt-8 font-sans text-lg md:text-xl text-ink/70 leading-relaxed max-w-3xl">
                {c.body}
              </p>
            </div>
          </motion.article>
        ))}
      </div>
    </section>
  );
}
